/**
 * Single source of truth for all test environments.
 * To add a new env, append one entry here — nothing else needs to change.
 *
 * audienceDomain: the Auth0-registered API identifier domain for this env.
 * Source: LEAGUE_TESTX_DOMAIN values in the Auth0 tenant config.
 */
export const TEST_ENVS = [
  { key: 'test1-ca', audienceDomain: 'test1.ca.league.dev' },
  { key: 'test2-ca', audienceDomain: 'test2.league.dev' },
  { key: 'test3-ca', audienceDomain: 'test3.league.dev' },
  { key: 'test4-ca', audienceDomain: 'test4.league.dev' },
  { key: 'test5-ca', audienceDomain: 'test5-ca.league.dev' },
  { key: 'test6-ca', audienceDomain: 'test6.ca.league.dev' },
  { key: 'test7-ca', audienceDomain: 'test7.ca.league.dev' },
  { key: 'test8-ca', audienceDomain: 'test8.ca.league.dev' },
  { key: 'test9-ca', audienceDomain: 'test9.ca.league.dev' },
  { key: 'test10-ca', audienceDomain: 'test10.ca.league.dev' },
  { key: 'test11-ca', audienceDomain: 'test11.ca.league.dev' },
] as const;

export type TestEnvironmentKey = (typeof TEST_ENVS)[number]['key'];

export type EosEnvironmentKey = '' | 'staging' | 'prod' | TestEnvironmentKey;

/** Ordered list of test env keys, derived from TEST_ENVS. */
export const TEST_ENV_KEYS = TEST_ENVS.map(
  (e) => e.key,
) as ReadonlyArray<TestEnvironmentKey>;
